module.exports = (parcelRequire.load("kH1zH")).then(() => parcelRequire('qK8we'));